import { defineComponent as _defineComponent } from 'vue'
import Wizard from '@/components/wizard/Wizard.vue';
import PersonalDataWizardStep from './steps/PersonalDataWizardStep.vue';
import SummaryWizardStep from './steps/SummaryWizardStep.vue';
import { User } from '@/models/user';
import { useUserWizard } from './user-wizard-utils';
import { useI18n } from '@/composables/i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'GlobalAdminWizard',
  props: {
    user: { default: null }
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as { user: User | null };





const {
  userCopy,
  submit: onSubmit,
  isEdit,
} = useUserWizard(props, emit, User.emptyGlobalAdmin());
const { t } = useI18n();

return { __sfc: true,props, emit, userCopy, onSubmit, isEdit, t, Wizard, PersonalDataWizardStep, SummaryWizardStep }
}

})